import { isString } from 'lodash/fp';
import { DateTime } from 'luxon';
import { DateTimeLocalizationInfo } from '@mews-framework/globalization';
import { ISOFormat, LocalizationFormatName } from '../enums';

export const formatLuxon = (
    formatStringName: LocalizationFormatName,
    localizationInfo: DateTimeLocalizationInfo | ISOFormat,
    luxonObject: DateTime
) => {
    // This is an edge case for when the provided localizationInfo is actually a format string. Will be fixed in the future.
    if (isString(localizationInfo)) {
        return luxonObject.toFormat(localizationInfo);
    }

    // formatDynamicDate helper for masked fields adds -normalized suffix to the culture code, and Luxon doesn't support it.
    const parsedCultureCode = localizationInfo.cultureCode.split('-normalized')[0];

    return luxonObject.setLocale(parsedCultureCode).toFormat(localizationInfo[formatStringName]);
};
